import { Col, Typography } from "antd";
import React from "react";
import { useIntl } from "react-intl";
import { IAdditionalField } from "../../Orchestrator/Types/Interface/IServiceRequest";
import { isEmpty } from "../../Lib/Utils/validationUtil";

interface TitleFieldProps {
  field: IAdditionalField;
  stopName?: string;
  span?: number;
}

const TitleField: React.FC<TitleFieldProps> = ({
  field,
  stopName,
  span = 24,
}) => {
  const intl = useIntl();

  if (isEmpty(field.title) && isEmpty(stopName)) return <></>;  
  return (
    <Col span={span} className="mb-10">
      <Typography.Text className="fs-16 fw-600">
        {field?.title && intl.formatMessage({ id: field.title })}
        {!isEmpty(stopName) && <span className="ml-5">{`(${stopName})`}</span>}
        {/* {field?.required && <span className="cancel-color ml-5">*</span>} */}
        {!field?.required && (
          <span className="cancel-color ml-5">
            ({intl.formatMessage({ id: "OPTIONAL" })})
          </span>
        )}
      </Typography.Text>
    </Col>
  );
};

export default TitleField;
